S.quiz =
    {
        elements: {
            $letsGo: null,
            $header: null,
            $number: null,
            $question: null,
            $btnYes: null,
            $btnNo: null,
            $questions: null,
            $result: null,
            $pagination: null,
            $passToShare: null,
            $share: null,
            $shareBtn: null,
            $modal: null,
            $link: null,
            $closeModal: null,
            $questionsObject: {
                question1: 'Sagt dir der Begriff “Fairer Handel” was?',
                question2: 'Weißt du, wie du fair gehandelte Produkte beim Einkaufen erkennen kannst?',
                question3: 'Weißt du, wie der Klimawandel und der faire Handel zusammenhängen?',
                question4: 'Weißt du, wie sich fair gehandelte Lebensmittel auf das Leben von Kleinbauernfamilien auswirken?',
                question5: 'Kannst du sagen, wo die Baumwolle für dein T-Shirt herkommt?',
                question6: 'Wusstest du, dass du dich beim Einkaufen für Frauenrechte einsetzen kannst?',
                question7: 'Wird bei dir auf der Arbeit fair gehandelter Kaffee getrunken?',
                question8: 'Interessierst du dich für nachhaltige Kosmetik?',
                question9: 'Hast du schon einmal vom Lieferkettensorgfalts<span style="color: transparent; font-size: 1px">-</span>pflichtengesetz gehört?',
                question10: 'Weißt du, wo die Futtermittel für Viehzucht herkommen?',
                link1: 'https://ichwillfair.de/fairer-handel/',
                link2: 'https://ichwillfair.de/artikel/fair-erkennen-siegel-und-labels/',
                link3: 'https://ichwillfair.de/artikel/gleich-zwei-schwere-hurrikans-bedrohen-mittelamerikas-kaffeeanbau/',
                link4: 'https://ichwillfair.de/artikel/reise-nach-nono-sale-auf-den-spuren-von-wildkaffee-und-imkereien/',
                link5: 'https://ichwillfair.de/artikel/vom-saatkorn-bis-zur-textilie-die-lange-lieferkette-der-baumwolle/',
                link6: 'https://ichwillfair.de/artikel/kooperativen/',
                link7: 'https://ichwillfair.de/artikel/der-kaffee-wird-knapp/',
                link8: 'https://ichwillfair.de/artikel/viel-mehr-als-nur-irgendein-geschenk-dr-bronners-fair-produzierte-bio-zertifizierte-naturseifen-und-bio-naturkosmetik/',
                link9: 'https://ichwillfair.de/artikel/brauchen-lieferketten-haftungsregeln/',
                link10: 'https://ichwillfair.de/artikel/tropenwaelder-alle-17-sekunden-verschwindet-ein-fussballfeld/',
            },
            $answers: {
                answer1: 9,
                answer2: 9,
                answer3: 9,
                answer4: 9,
                answer5: 9,
                answer6: 9,
                answer7: 9,
                answer8: 9,
                answer9: 9,
                answer10: 9,
            },
        },


        init()
        {
            this.initClicks();
        },

        initClicks()
        {
            this.elements.$btnYes.on('click', () =>
            {
                this.nextQuestion(1);
            });

            this.elements.$btnNo.on('click', () =>
            {
                this.nextQuestion(0);
            });

            this.elements.$letsGo.on('click', () =>
            {
                this.beginOfQuestions();
            });

            this.elements.$pagination.children().eq(0).on('click', () =>
            {
                this.previousQuestion();
            });

            this.elements.$pagination.children().eq(2).on('click', () =>
            {
                this.nextQuestionWithoutAnswer();
            });

            this.elements.$passToShare.on('click', () =>
            {
                this.passToShare();
            });

            this.elements.$shareBtn.on('click', () =>
            {
                this.showModal();
            });

            this.elements.$closeModal.on('click', () =>
            {
                this.hideModal();
            });
        },

        nextQuestion($answer)
        {
            this.elements.$pagination.children().eq(1).text('0' + (Number(this.elements.$pagination.children().eq(1).text().substring(0, 2)) + 1) + '/10');

            if (this.elements.$pagination.children().eq(1).text().length > 5)
            {
                this.elements.$pagination.children().eq(1).text(this.elements.$pagination.children().eq(1).text().substring(1, 6));
            }

            this.elements.$answers[0]['answer' + Number(this.elements.$number.text())] = $answer;

            if (Number(this.elements.$number.text()) === 10)
            {
                this.displayResult();

                return;
            }

            this.displayQuestion(Number(this.elements.$number.text()) + 1);
        },

        nextQuestionWithoutAnswer()
        {
            if (Number(this.elements.$number.text()) === 10)
            {
                return;
            }

            this.elements.$pagination.children().eq(1).text('0' + (Number(this.elements.$number.text()) + 1) + '/10');

            if (this.elements.$pagination.children().eq(1).text().length > 5)
            {
                this.elements.$pagination.children().eq(1).text(this.elements.$pagination.children().eq(1).text().substring(1, 6));
            }

            this.displayQuestion(Number(this.elements.$number.text()) + 1);
        },

        displayQuestion($question)
        {
            this.elements.$number.text($question + '.');
            this.elements.$question.html(this.elements.$questionsObject[0]['question' + $question]);
            this.elements.$link.attr('href', this.elements.$questionsObject[0]['link' + $question]);
            this.elements.$pagination.children().eq(0).removeClass('is-hidden');
            this.elements.$pagination.children().eq(2).removeClass('is-hidden');

            if ($question === 1)
            {
                this.elements.$pagination.children().eq(0).addClass('is-hidden');
            }
            else if ($question === 10)
            {
                this.elements.$pagination.children().eq(2).addClass('is-hidden');
            }
        },

        displayResult()
        {
            let $result = 0;

            for (let i = 1; i <= 10; i++)
            {
                if (this.elements.$answers[0]['answer' + i] === 1)
                {
                    $result++;
                }

                else if (this.elements.$answers[0]['answer' + i] === 9)
                {
                    $(this.elements.$pagination.children()[1]).text('0' + i + '/10');
                    this.displayQuestion(i);

                    return;
                }
            }

            this.elements.$questions.hide();
            this.elements.$result.show();
            this.elements.$header.find('svg').hide();

            if ($result < 4)
            {
                this.elements.$result.addClass('is-red');
            }
            else if ($result < 7)
            {
                this.elements.$result.addClass('is-yellow');
            }
            else
            {
                this.elements.$result.addClass('is-green');
            }
        },

        beginOfQuestions()
        {
            this.elements.$header.addClass('is-minimal');
            this.elements.$questions.addClass('is-visible');
            this.displayQuestion(1);
        },

        previousQuestion()
        {
            if (Number(this.elements.$number.text()) === 1)
            {
                return;
            }

            this.elements.$pagination.children().eq(1).text('0' + (Number(this.elements.$number.text()) - 1) + '/10');
            this.displayQuestion(Number(this.elements.$number.text()) - 1);
        },

        passToShare()
        {
            this.elements.$share.children().hide('slow');
            this.elements.$share.children().eq(4).show('slow');
            this.elements.$share.children().eq(5).show('slow');
        },

        showModal()
        {
            this.elements.$modal.show();
        },

        hideModal()
        {
            this.elements.$modal.hide();
        },
    };
